import { BOUNCER_PERMISSIONS } from "../../../constants/bouncerPermissions";

export const TARS_MODULES = [
  {
    link: "/dashboard/beamsaw",
    searchObj: "beamsaw",
    icon: "list_alt",
    label: "Beamsaw",
    production: true,
  },
  {
    link: "/dashboard/qcsort",
    searchObj: "qcsort",
    icon: "grid_view",
    label: "Sorting",
    production: true,
  },
  {
    link: "/dashboard/qccheck",
    searchObj: "qccheck",
    icon: "inventory_2",
    label: "QC",
    production: true,
  },
  {
    link: "/dashboard/image-search",
    searchObj: "image-search",
    icon: "work_history",
    label: "Utilities",
    production: true,
  },
  {
    link: "/dashboard/invoice-management",
    // Array = OR logic: user needs any one of these to access the module
    bouncerKey: [BOUNCER_PERMISSIONS.PO_VIEW, BOUNCER_PERMISSIONS.INVOICE_MANAGEMENT_VIEW],
    searchObj: "invoice-management",
    icon: "receipt",
    label: "Invoice Management",
  },
  {
    link: "/dashboard/vendor-onboarding",
    bouncerKey: BOUNCER_PERMISSIONS.VENDOR_ONBOARD,
    searchObj: "vendor-onboarding",
    icon: "person_add",
    label: "Vendor Onboarding",
  },
];
